// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * formElements.css
 * Copyright 2017 - 2020 by ChartIQ, Inc.
 * All rights reserved.
 */

.form-group {
	/* display: flex; */
	flex-direction: row;
	margin: 16px 0;
	padding-right: 5px;
	justify-content: center;
}

.form-group label {
	padding-top: 7px;
	flex: 0.4;
}

.form-group input,
.form-group select {
	flex: 0.65;
}
`, "",{"version":3,"sources":["webpack://./src/ui/assets/css/core/formElements.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;CACC,mBAAmB;CACnB,mBAAmB;CACnB,cAAc;CACd,kBAAkB;CAClB,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,SAAS;AACV;;AAEA;;CAEC,UAAU;AACX","sourcesContent":["/*!\n * formElements.css\n * Copyright 2017 - 2020 by ChartIQ, Inc.\n * All rights reserved.\n */\n\n.form-group {\n\t/* display: flex; */\n\tflex-direction: row;\n\tmargin: 16px 0;\n\tpadding-right: 5px;\n\tjustify-content: center;\n}\n\n.form-group label {\n\tpadding-top: 7px;\n\tflex: 0.4;\n}\n\n.form-group input,\n.form-group select {\n\tflex: 0.65;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
